import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { activityService } from '@/services/activity';
import { applicationService } from '@/services/applications';
import { creditService } from '@/services/credit';
import { rfmService } from '@/services/rfm';
import { statisticsService } from '@/services/statistics';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAccountDetail() {
    const router = useAppRouter();
    const route = useRoute();

    const model = reactive({
        accountId: Number(route.params.accountId),
        account: {} as any,
        lastLogin: {} as any,
        avgPayment: {} as any,
        rfmSegmentation: {} as any,
        onlineTime: 0
    });

    const fetch = async () => {
        const [accountResponse, avgPaymentResponse, segmentationResponse, loginResponse, statsResponse] =
            await Promise.all([
                applicationService.account.get(model.accountId),
                creditService.getAvgPayment(model.accountId),
                rfmService.segmentation.get(model.accountId),
                activityService.account.getLastLogin(model.accountId),
                statisticsService.stats(model.accountId)
            ]);

        if (accountResponse.code === ResponseCode.Ok) {
            model.account = accountResponse.data;
        } else {
            router.go(-1);
        }

        if (avgPaymentResponse.code === ResponseCode.Ok) {
            model.avgPayment = avgPaymentResponse.data;
        }

        if (segmentationResponse.code === ResponseCode.Ok) {
            model.rfmSegmentation = segmentationResponse.data;
        }

        if (loginResponse.code === ResponseCode.Ok) {
            model.lastLogin = loginResponse.data;
        }

        if (statsResponse.code === ResponseCode.Ok) {
            model.onlineTime = Number(statsResponse.data) * 1000;
        }
    };

    return { model, fetch };
}
